// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label h1 {
  font-weight: 700;
}
ion-label h2 {
  margin-bottom: 16px;
  font-weight: 500;
}
ion-label p ion-icon {
  margin: 0;
  width: 16px;
  height: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/settings/components/gmb-location-picker/gmb-account-select.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAEE;EACE,mBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,SAAA;EACA,WAAA;EACA,YAAA;AAAJ","sourcesContent":["ion-label {\n  h1 {\n    font-weight: 700;\n  }\n  h2 {\n    margin-bottom: 16px;\n    font-weight: 500;\n  }\n  p ion-icon {\n    margin: 0;\n    width: 16px;\n    height: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
